import React from 'react';
import { FacebookIcon, InstagramIcon, MailIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { Logo } from './Logo';
import { WhatsAppButton } from './WhatsAppButton';
import { DOMAIN, EMAIL, PHONE_PERU_DISPLAY, PHONE_USA_DISPLAY, QUOTE_MESSAGE, whatsappUrl } from '../utils/contact';
const navItems = [{
  label: 'Inicio',
  href: '#inicio'
}, {
  label: 'Portafolio',
  href: '#portafolio'
}, {
  label: 'Servicios',
  href: '#servicios'
}, {
  label: 'Acerca de mí',
  href: '#acerca'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink-900" data-id="element-79" data-mp="3levgj10wbefn">
      <div className="mx-auto grid max-w-page gap-12 px-5 py-16 lg:grid-cols-[1.4fr_0.8fr_1fr] lg:px-8" data-id="element-80" data-mp="3lggb2qn7mxdi">
        <div data-id="element-81" data-mp="3qf9qiom24ygb">
          <Logo size="lg" data-id="element-82" data-mp="29z6x2jmuoxjl" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-mist-muted" data-id="element-83" data-mp="29yxbd88u9cjp">
            Agencia digital enfocada en diseño web de alta conversión, presencia online y
            estrategias digitales para negocios en USA y Latinoamérica.
          </p>
          <div className="mt-6 flex items-center gap-3" data-id="element-84" data-mp="3lbdcst8dy9lt">
            <a href="https://www.instagram.com/yennileal09/" target="_blank" rel="noopener noreferrer" aria-label="Instagram de YenniDigital" className="grid h-10 w-10 place-items-center rounded-lg border border-white/12 text-mist-muted transition-colors duration-200 ease-out hover:border-neon/60 hover:text-neon" data-id="element-85" data-mp="3gbqz6ionarch">
              <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-86" data-mp="335u5kj2dpi2" />
            </a>
            <a href="https://www.instagram.com/yennileal09/" target="_blank" rel="noopener noreferrer" aria-label="Facebook de YenniDigital" className="grid h-10 w-10 place-items-center rounded-lg border border-white/12 text-mist-muted transition-colors duration-200 ease-out hover:border-neon/60 hover:text-neon" data-id="element-87" data-mp="hrs6dddea152">
              <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-88" data-mp="tw5y45mchom7" />
            </a>
            <a href={whatsappUrl(QUOTE_MESSAGE)} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp de YenniDigital" className="grid h-10 w-10 place-items-center rounded-lg border border-white/12 text-mist-muted transition-colors duration-200 ease-out hover:border-neon/60 hover:text-neon" data-id="element-89" data-mp="ytoa64vnsjyf">
              <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="1hkfg0wgfts82" />
            </a>
          </div>
        </div>

        <nav aria-label="Navegación del footer" data-id="element-91" data-mp="1mjijwdkolseg">
          <h2 className="text-xs uppercase tracking-[0.18em] text-mist-dim" data-id="element-92" data-mp="1mhpawrmliw3a">Secciones</h2>
          <ul className="mt-5 flex flex-col gap-3" data-id="element-93" data-mp="1ri3lagbo6i4h">
            {navItems.map(item => <li key={item.href} data-id="element-94" data-mp="3ocq1xuroio41">
                <a href={item.href} className="text-sm text-mist-muted transition-colors duration-200 ease-out hover:text-neon" data-id="element-95" data-mp="3ta8cfplchbe5">
                  {item.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div data-id="element-96" data-mp="21mtg828nolz7">
          <h2 className="text-xs uppercase tracking-[0.18em] text-mist-dim" data-id="element-97" data-mp="21mjyt31ofn54">Contacto</h2>
          <ul className="mt-5 flex flex-col gap-3 text-sm text-mist-muted" data-id="element-98" data-mp="1wnpajlkxx6dm">
            <li className="flex items-start gap-3" data-id="element-99" data-mp="1wlm9m6i91su4">
              <MessageCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-neon" aria-hidden="true" data-id="element-100" data-mp="2te99gf4px6ye" />
              <span data-id="element-101" data-mp="2pc4hrlxtykee">
                USA / WhatsApp Business
                <a href={whatsappUrl(QUOTE_MESSAGE)} target="_blank" rel="noopener noreferrer" className="mt-0.5 block text-white transition-colors duration-200 ease-out hover:text-neon" data-id="element-102" data-mp="2kdb7019xh7hx">
                  {PHONE_USA_DISPLAY}
                </a>
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-103" data-mp="13xqfn9k2ef11">
              <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-neon" aria-hidden="true" data-id="element-104" data-mp="2rv7s6610we50" />
              <span data-id="element-105" data-mp="2wmzhkd8g0dtk">
                Perú
                <a href={`tel:${PHONE_PERU_DISPLAY.replace(/\s/g, '')}`} className="mt-0.5 block text-white transition-colors duration-200 ease-out hover:text-neon" data-id="element-106" data-mp="2wo0rufhmwwa8">
                  {PHONE_PERU_DISPLAY}
                </a>
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-107" data-mp="3bhm61klsvq9e">
              <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-neon" aria-hidden="true" data-id="element-108" data-mp="3fllldzvcgj16" />
              <a href={`mailto:${EMAIL}`} className="text-white transition-colors duration-200 ease-out hover:text-neon" data-id="element-109" data-mp="31m2cv5ymf5oc">
                {EMAIL}
              </a>
            </li>
          </ul>

          <WhatsAppButton message={QUOTE_MESSAGE} variant="outline" size="sm" className="mt-6" data-id="element-110" data-mp="1q4sxauim4xsb">
            Contactar por WhatsApp
          </WhatsAppButton>
        </div>
      </div>

      <div className="border-t border-white/8" data-id="element-111" data-mp="1nkmq8dypcr7j">
        <div className="mx-auto flex max-w-page flex-col gap-2 px-5 py-6 text-xs text-mist-dim sm:flex-row sm:items-center sm:justify-between lg:px-8" data-id="element-112" data-mp="1imv11rpfzj71">
          <p data-id="element-113" data-mp="1wlcm1hnyqhl9">© {new Date().getFullYear()} YenniDigital. Todos los derechos reservados.</p>
          <p className="text-neon" data-id="element-114" data-mp="1rom1ah17qxti">{DOMAIN}</p>
        </div>
      </div>
    </footer>;
}